var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#198754"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_11620)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(7.53906 7.67969)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5386 16.6787C17.4337 16.6787 18.2921 16.3231 18.9251 15.6902C19.558 15.0573 19.9136 14.1988 19.9136 13.3037C19.9136 12.4086 19.558 11.5502 18.9251 10.9172C18.2921 10.2843 17.4337 9.92871 16.5386 9.92871C15.6435 9.92871 14.785 10.2843 14.1521 10.9172C13.5192 11.5502 13.1636 12.4086 13.1636 13.3037C13.1636 14.1988 13.5192 15.0573 14.1521 15.6902C14.785 16.3231 15.6435 16.6787 16.5386 16.6787ZM18.7886 13.3037C18.7886 13.9004 18.5515 14.4727 18.1296 14.8947C17.7076 15.3167 17.1353 15.5537 16.5386 15.5537C15.9418 15.5537 15.3695 15.3167 14.9476 14.8947C14.5256 14.4727 14.2886 13.9004 14.2886 13.3037C14.2886 12.707 14.5256 12.1347 14.9476 11.7127C15.3695 11.2908 15.9418 11.0537 16.5386 11.0537C17.1353 11.0537 17.7076 11.2908 18.1296 11.7127C18.5515 12.1347 18.7886 12.707 18.7886 13.3037ZM23.2886 22.3037C23.2886 23.4287 22.1636 23.4287 22.1636 23.4287H10.9136C10.9136 23.4287 9.78857 23.4287 9.78857 22.3037C9.78857 21.1787 10.9136 17.8037 16.5386 17.8037C22.1636 17.8037 23.2886 21.1787 23.2886 22.3037ZM22.1636 22.2992C22.1624 22.0225 21.9903 21.19 21.2276 20.4272C20.4941 19.6937 19.1137 18.9287 16.5386 18.9287C13.9623 18.9287 12.5831 19.6937 11.8496 20.4272C11.0868 21.19 10.9158 22.0225 10.9136 22.2992H22.1636Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_11620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7.53906 7.67969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon2);
export default __webpack_public_path__ + "static/media/user_icon_2.27ca923e6613b09bc0b771dda71e7636.svg";
export { ForwardRef as ReactComponent };